module.exports = __webpack_public_path__ + "img/9ad6014.svg";